import React from "react";
import giftCard from "../../assets/images/prizes/costa-gift-card.png";
import { prizes } from "../../constants/prizes";

export const PrizeCard = ({ prize }) => (
  <div className="flex flex-col w-full mb-8">
    {prize?.image && (
      <div className="prize-image-box">
        <img
          id={prize?.id}
          className="prize-image "
          src={prize.image}
          alt="Costa Gifts"
        />
      </div>
    )}
    {prize?.image ? (
      prize.name == prizes[3].name ? (
        <h1 className="mb-4 font-bold text-red">
          {prize.name.split(" ").map((word, index) => (
            <React.Fragment key={index}>
              {word}
              {index === 0 && <br />}
            </React.Fragment>
          ))}
        </h1>
      ) : (
        <h1 className="mb-4 font-bold text-red">{prize?.name}</h1>
      )
    ) : (
      <h2 className="text-red mb-4 font-bold">{prize?.name}</h2>
    )}

    {prize?.description && <p className="text-red">{prize?.description}</p>}
  </div>
);

function Prizes() {
  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="mb-4 font-bold text-red">Prizes</h1>

      <p className="mx-auto mb-6 max-w-xs text-center text-red">
        With your Costa Express drink you have the chance to win one of our
        daily prizes listed below. You can enter once a day and keep coming back
        to try and win a new prize everyday. Good luck! 
      </p>

      <div className="prize-image-box">
        <img className="prize-image " src={giftCard} alt="Costa Gifts" />
      </div>
      <h1 className="mb-8 font-bold text-red">Costa gifts</h1>
      <PrizeCard prize={prizes[0]} />
      <PrizeCard prize={prizes[1]} />
      <PrizeCard prize={prizes[2]} />
      <PrizeCard prize={prizes[3]} />
      <PrizeCard prize={prizes[4]} />
      <PrizeCard prize={prizes[5]} />
      <PrizeCard prize={prizes[6]} />
      <PrizeCard prize={prizes[7]} />
      <PrizeCard prize={prizes[8]} />

      <button
        onClick={() => {
          window.location.replace("/");
        }}
        className="btn"
      >
        Enter now
      </button>
    </div>
  );
}

export default Prizes;
